/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // Fix: search popdown doesn't allow scrolling results on mobile because
  // theme.js's showPopdown() dispatches theme:scroll:lock without a target
  // element. We watch for the popdown opening and re-issue the lock event
  // pointing at the actual scrollable results container.
  (function () {
    var popdown = document.getElementById('search-popdown');
    if (!popdown) return;

    var resultsEl = popdown.querySelector('[data-predictive-search-results]');
    if (!resultsEl) return;

    var wasVisible = false;
    var observer = new MutationObserver(function () {
      var isVisible = popdown.classList.contains('is-visible');
      if (isVisible && !wasVisible) {
        // Let theme.js's own lock() call (setTimeout-based) run first,
        // then add our results container as an allowed scroll target.
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('theme:scroll:lock', {
            bubbles: true,
            detail: resultsEl
          }));
        }, 50);
      }
      wasVisible = isVisible;
    });

    observer.observe(popdown, { attributes: true, attributeFilter: ['class'] });
  })();

  // Fix: window.innerHeight doesn't shrink when the mobile keyboard opens,
  // so max-height calculations based on it don't account for the keyboard
  // covering part of the screen. VisualViewport reports the real visible
  // area, so we expose it as a CSS variable that updates live.
  (function () {
    if (!window.visualViewport) return;

    function updateVisualViewportHeight() {
      document.documentElement.style.setProperty('--visual-vh', window.visualViewport.height + 'px');
    }

    updateVisualViewportHeight();
    window.visualViewport.addEventListener('resize', updateVisualViewportHeight);
    window.visualViewport.addEventListener('scroll', updateVisualViewportHeight);
  })();

  // Fix: theme.js only wires up the FIRST element matching
  // [data-popdown-toggle="search-popdown"] (uses querySelector, not
  // querySelectorAll). Since we added a second search icon (mobile),
  // only one of the two ever gets its popdown click handler -- the
  // other falls through to its native href and just navigates to
  // the search page instead of opening the dropdown.
  //
  // Must run AFTER theme.js's own DOMContentLoaded handler (which is
  // what actually wires up the trigger via aria-haspopup), otherwise
  // neither trigger is wired yet when this code checks for it.
  document.addEventListener('DOMContentLoaded', function () {
    var triggers = document.querySelectorAll('[data-popdown-toggle="search-popdown"]');
    if (triggers.length < 2) return;

    var wired = null;
    triggers.forEach(function (el) {
      if (el.getAttribute('aria-haspopup') === 'true') wired = el;
    });
    if (!wired) return;

    triggers.forEach(function (el) {
      if (el === wired) return;
      el.addEventListener('click', function (evt) {
        evt.preventDefault();
        wired.click();
      });
    });
  });

  // Fix: the shipping-estimate country <select> starts empty and gets its
  // <option> elements injected asynchronously by the theme's address
  // library. That library doesn't appear to reliably honor our
  // data-default/data-default-fullname attributes, so once the options
  // exist, we select the right one ourselves -- matching by ISO code
  // first, falling back to matching the visible country name.
  (function () {
    var countrySelect = document.getElementById('estimate_address_country');
    if (!countrySelect) return;

    function applyDefaultCountry() {
      if (!countrySelect.options.length) return;
      var defaultCode = countrySelect.getAttribute('data-default');
      var defaultName = countrySelect.getAttribute('data-default-fullname');
      if (!defaultCode && !defaultName) return;

      var matchedOption = null;
      Array.prototype.forEach.call(countrySelect.options, function (opt) {
        if (matchedOption) return;
        if (defaultCode && opt.value === defaultCode) {
          matchedOption = opt;
        } else if (defaultName && opt.text.trim() === defaultName.trim()) {
          matchedOption = opt;
        }
      });

      if (matchedOption && countrySelect.value !== matchedOption.value) {
        countrySelect.value = matchedOption.value;
        countrySelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var observer = new MutationObserver(function () {
      if (countrySelect.options.length > 0) {
        applyDefaultCountry();
        observer.disconnect();
      }
    });
    observer.observe(countrySelect, { childList: true });

    // In case options are already populated by the time this runs
    applyDefaultCountry();
  })();

  // Make the Judge.me reviews carousel header (title + star rating)
  // a clickable link through to the full reviews page.
  (function () {
    var header = document.querySelector('.jdgm-header');
    if (!header) return;

    var link = document.createElement('a');
    link.href = 'https://peakmotogear.com.au/pages/reviews';
    link.style.display = 'block';
    link.style.textDecoration = 'none';
    link.style.color = 'inherit';
    link.setAttribute('aria-label', 'View all customer reviews');

    header.parentNode.insertBefore(link, header);
    link.appendChild(header);
  })();

  // Fix: GeoStock's inventory widget is rendered with a static
  // data-variant-id at page load and doesn't appear to update when
  // Pipeline switches variants via AJAX. We keep its attribute in sync
  // and re-dispatch a few common variant-change event name conventions,
  // since we don't have visibility into which one GeoStock listens for.
  document.addEventListener('theme:variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    var widget = document.querySelector('.geostock-product-inventory');
    if (!widget) return;

    widget.setAttribute('data-variant-id', variant.id);

    ['variant:change', 'product:variant:change', 'variantChange'].forEach(function (eventName) {
      document.dispatchEvent(new CustomEvent(eventName, {
        detail: { variant: variant },
        bubbles: true
      }));
      widget.dispatchEvent(new CustomEvent(eventName, {
        detail: { variant: variant },
        bubbles: true
      }));
    });
  });

  // Sticky Add to Cart bar: shows once the real buy box scrolls out of
  // view, and submits the REAL product form (not a duplicate) so variant
  // selection, AJAX cart behavior, etc. all stay exactly as-is.
  (function () {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var formId = bar.getAttribute('data-target-form');
    var form = document.getElementById(formId);
    if (!form) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    observer.observe(form);

    bar.querySelector('[data-sticky-atc-submit]').addEventListener('click', function () {
      var realSubmitButton = form.querySelector('button[type="submit"], [data-add-to-cart]');
      if (realSubmitButton) {
        realSubmitButton.click();
      } else if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });

    document.addEventListener('theme:variant:change', function (e) {
  var variant = e.detail && e.detail.variant;
  if (!variant) return;

  var variantEl = bar.querySelector('[data-sticky-atc-variant]');
  if (variantEl) variantEl.textContent = variant.title;

  var priceEl = bar.querySelector('[data-sticky-atc-price]');
  if (priceEl && variant.price != null) {
    priceEl.textContent = '$' + (variant.price / 100).toFixed(2);
  }
});
  })();

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();